import React, { useContext, Fragment } from 'react';

import proyectoContext from '../../context/proyectos/proyectoContext';
import tareaContext from '../../context/tareas/tareaContext';
import AuthState from '../../context/autenticacion/authContext';

import { MdCheck, MdClose } from "react-icons/md";
import { BsTrash } from "react-icons/bs";
import { FaRegEdit, FaRegEye } from "react-icons/fa";
import Swal from 'sweetalert2';

const Tarea = ({tarea}) => {

    // Extraer si un proyecto está activo
    const proyectosContext = useContext(proyectoContext);
    const { proyecto, obtenerUltimosCambios, guardarUltimoCambio } = proyectosContext;

    // Obtener la funcion del context de tarea
    const tareasContext = useContext(tareaContext);
    const {
        cambiarEstado,
        tareaEliminar,
        seleccionarTarea,
        verTarea,
        tareaActual,
        obtenerDescripciones,
        formularioDescripcion 
    } = tareasContext;
    
    // Extraer usuario logeado
    const authState = useContext(AuthState);
    const { usuario } = authState;

    // Extraer el proyecto
    const [ proyectoActual ] = proyecto;

    // Funcion que ejecuta al cambiar estado
    const handleEstado = () => {
        cambiarEstado(tarea);
        guardarUltimoCambio(proyectoActual._id, 'Tarea', tarea.nombre, 'Actualizó el estado');
        obtenerUltimosCambios(proyectoActual._id); // Filtra los ultimos cambios
    }

    // Cuando ejecuta la accion de ver la tarea
    const verTareaActual = tarea => {
        verTarea(true);
        formularioDescripcion(true);
        tareaActual(tarea);
        // guardarTareaSeleccionada(tarea);
        obtenerDescripciones(tarea._id);
    }

    // Funcion que ejecuta al eliminar
    const handleEliminar = () => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: "Un tarea que se elimina no se puede recuperar.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2f3848',
            cancelButtonColor: '#be3434',
            confirmButtonText: 'Si, ¡eliminalo!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.value) {
                tareaEliminar(tarea._id, proyectoActual._id);
                guardarUltimoCambio(proyectoActual._id, 'Tarea', tarea.nombre, 'Eliminó la tarea');
                obtenerUltimosCambios(proyectoActual._id); // Filtra los ultimos cambios
            }
        });
    };

    return ( 
        <li className="tarea sombra">

            <div className="estado">
                {tarea.estado
                    ? 
                        (
                            <button
                                type="button"
                                className="completo"
                                onClick={() => handleEstado()}
                            >
                                <MdCheck />
                            </button>
                            
                        )
                    :
                        (
                            <button
                                type="button"
                                className="incompleto"
                                onClick={() => handleEstado()}
                            >
                                <MdClose />
                            </button>
                        )
                }
            </div>
            
            <div className="tarea-nombre">
                <p className="fecha-creacion">{tarea.fechaCreacion}</p>
                <p>{tarea.nombre}</p>
            </div>
            
            <div className="tarea-para">
                <p>{tarea.para}</p>
            </div>

            <div className="acciones">
                <button
                    type="button"
                    className="btn btn-editar-tarea"    
                    onClick={() => verTareaActual(tarea)}
                >
                    <FaRegEye />
                </button>
                
                { usuario ? (
                    usuario.rol === 'Administrador' ? (
                        <Fragment>
                            <button
                                type="button"
                                className="btn btn-editar-tarea"   
                                onClick={() => seleccionarTarea(tarea)} 
                            >
                                <FaRegEdit />
                            </button>
                            
                            <button
                                type="button"
                                className="btn btn-eliminar-tarea"
                                onClick={() => handleEliminar()}
                            >
                                <BsTrash />
                            </button>
                        </Fragment>
                    ) : null
                ) : null }

            </div>
        </li>
    );
}
 
export default Tarea;